/* ============================================================
   1) Puntos interactivos del hero: click en el dot → tarjeta del perfume
   2) Ventanas: popup de Caché Match y lupa de las fotos de las reseñas
   3) Carrusel de reseñas
   ============================================================ */
/* ============================================================
   Caché Perfume · comportamiento común de las secciones
     1) puntos del hero      4) cinta de TikTok (marquesina) + reproductor
     2) ventanas modales     5) entrada en cascada de las secciones
     3) carruseles de flechas
   ------------------------------------------------------------
   ⚠️ Cada sección pide este archivo por su cuenta, así que Shopify puede
   emitir el <script> más de una vez en la misma página. La guarda de abajo
   hace que el segundo pase no haga nada: sin ella se duplicarían todos los
   listeners y cada click abriría y cerraría la misma tarjeta.
   ============================================================ */
if (!window.__cacheApp) {
  window.__cacheApp = true;

(function () {

  /* Busca el ancestro que coincida con el selector, partiendo de donde ocurrió el evento.
     ⚠️ No usar `e.target.closest(...)` a secas: el target no siempre es un Element — un evento
     disparado sobre el `document` (o que caiga en un nodo de texto) no tiene closest() y la
     llamada revienta con TypeError. Acá se comprueba antes. */
  function cerca(e, selector) {
    return e.target instanceof Element ? e.target.closest(selector) : null;
  }

  /* Escapa lo que va a parar a un atributo o al innerHTML. Es la misma función que la de
     js/cart.js: los dos archivos son independientes a propósito y ninguno depende del otro.
     Hace falta de verdad: en el catálogo hay 35 productos con "&" en el nombre
     (Dolce & Gabbana, Viktor & Rolf) y 13 con apóstrofo (L'eau D'issey). */
  function escapar(txt) {
    return String(txt).replace(/[&<>"']/g, c =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  /* ⚠️ EN EL PERSONALIZADOR DE SHOPIFY las secciones se vuelven a pintar sin recargar la
     página: el <script> NO se ejecuta otra vez, así que todo lo que se ata a un elemento
     concreto se pierde y la sección editada queda muerta hasta que el merchant recarga.
     Por eso todo lo que ata listeners a elementos vive en montar(), que se vuelve a llamar
     con cada shopify:section:load, y nuevos() se saltea lo que ya está montado para no
     duplicar nada. Lo que va delegado en el document se registra UNA sola vez, acá afuera. */
  /* ⚠️ Un WeakSet POR SELECTOR, no uno solo para todo. Con uno solo, el primer selector
     que tocara un elemento se lo quedaba y el resto lo salteaba — y hay elementos que
     matchean dos: .voices y .best son [data-carousel] Y [data-reveal] a la vez. Con el
     WeakSet compartido, el carrusel se los llevaba y la cascada nunca los observaba, así
     que las secciones se quedaban en opacity:0 para siempre. Medido. */
  const yaMontado = new Map();

  function nuevos(selector, raiz) {
    let vistos = yaMontado.get(selector);
    if (!vistos) { vistos = new WeakSet(); yaMontado.set(selector, vistos); }
    return Array.from((raiz || document).querySelectorAll(selector)).filter(el => {
      if (vistos.has(el)) return false;
      vistos.add(el);
      return true;
    });
  }

  /* ---------- Puntos del hero ---------- */
  /* Se consulta en vivo y no se guarda una lista: en el personalizador el hero se
     puede repintar y la lista vieja apuntaría a nodos que ya no están en la página. */
  function hotspots() {
    return Array.from(document.querySelectorAll('.hotspot'));
  }

  function closeHotspot(hotspot) {
    hotspot.classList.remove('is-open');
    const dot = hotspot.querySelector('.hotspot__dot');
    if (dot) dot.setAttribute('aria-expanded', 'false');
  }

  function closeAllHotspots(except) {
    hotspots().forEach(h => { if (h !== except) closeHotspot(h); });
  }


  /* Click fuera → cerrar todas las tarjetas */
  document.addEventListener('click', e => {
    if (!cerca(e, '.hotspot')) closeAllHotspots(null);
  });

  /* Imágenes opcionales (la botella del Match, las miniaturas de TikTok): si el archivo no
     existe se esconde la <img> para que no salga el icono de "imagen rota" y quede el
     respaldo de abajo. En cuanto el archivo esté en su sitio, aparece sola.
     Es una función y no un bucle suelto porque la marquesina clona tarjetas después de
     cargar la página y esas copias también necesitan el respaldo. */
  const opcionalesListas = new WeakSet();

  function activarOpcionales(raiz) {
    raiz.querySelectorAll('img[data-optional]').forEach(img => {
      if (opcionalesListas.has(img)) return;   /* los clones son otros nodos: no se saltan */
      opcionalesListas.add(img);
      img.addEventListener('error', () => { img.style.display = 'none'; });
      img.addEventListener('load',  () => { img.style.display = ''; });
      if (img.complete && img.naturalWidth === 0) img.style.display = 'none';
    });
  }


  /* ============================================================
     Ventanas modales — una sola mecánica para el popup de Match y para la lupa
     ============================================================ */
  let ultimoFoco = null;
  let abierta = null;

  function abrirVentana(modal, disparador) {
    if (!modal) return;
    ultimoFoco = disparador || document.activeElement;
    modal.hidden = false;
    void modal.offsetHeight;              /* fuerza el reflow para que la transición
                                             arranque desde el estado cerrado */
    modal.classList.add('is-open');
    abierta = modal;
    if (disparador && disparador.hasAttribute('aria-expanded')) {
      disparador.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';

    /* El foco va al aspa: es un control real, así el teclado cae en algo útil y no
       queda un recuadro de foco alrededor de todo el panel. */
    const aspa = modal.querySelector('.modal__close');
    const panel = modal.querySelector('.modal__panel');
    if (aspa) {
      aspa.focus();
    } else if (panel) {
      panel.setAttribute('tabindex', '-1');
      panel.focus();
    }
  }

  function cerrarVentana(modal) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    if (abierta === modal) abierta = null;

    const panel = modal.querySelector('.modal__panel');
    const ocultar = () => {
      modal.hidden = true;
      /* Un iframe de video seguiría reproduciéndose detrás del telón: se vacía al cerrar.
         Se hace acá, cuando ya terminó la transición, para que no se ponga negro en pleno cierre. */
      modal.querySelectorAll('iframe').forEach(marco => marco.removeAttribute('src'));
    };
    if (panel) panel.addEventListener('transitionend', ocultar, { once: true });
    setTimeout(ocultar, 400);             /* red de seguridad si no dispara transitionend */

    /* El foco vuelve a quien la abrió. Nunca puede quedarse dentro del panel, porque
       el panel pasa a hidden y el foco se perdería. */
    if (ultimoFoco && ultimoFoco !== document.body && document.contains(ultimoFoco)) {
      if (ultimoFoco.hasAttribute('aria-expanded')) {
        ultimoFoco.setAttribute('aria-expanded', 'false');
      }
      ultimoFoco.focus();
    }
  }



  /* ---------- Caché Match: la tarjeta cuadrada que gira ----------
     En escritorio el giro lo hace SOLO el CSS (:hover y :focus-within). Acá no hay nada que hacer.

     ⚠️ Este bloque existe únicamente para el TÁCTIL, donde no hay hover: sin él, en un teléfono la
     tarjeta nunca giraría y el CTA de atrás sería inalcanzable. Se toca la tarjeta y se le pone
     .is-flip; se toca fuera y vuelve.

     La condición es (hover: none): así en escritorio no se cuelga la clase, que si no se quedaría
     pegada al salir el mouse y la tarjeta no volvería sola. */

  /* Tocar fuera la devuelve. Va delegado en el document: se registra una sola vez. */
  if (window.matchMedia('(hover: none)').matches) {
    document.addEventListener('click', e => {
      const dentro = e.target.closest && e.target.closest('[data-match-flip]');
      if (dentro) return;
      document.querySelectorAll('[data-match-flip].is-flip')
        .forEach(t => t.classList.remove('is-flip'));
    });
  }




  /* ============================================================
     Carruseles — sirve para las reseñas y para Best Sellers.
     Marcá la sección con [data-carousel], la lista con [data-track] y las flechas
     con [data-dir="-1|1"]. No hace falta tocar el JS para añadir otro.
     ============================================================ */


  /* ---------- Reproductor de TikTok ----------
     Cada tarjeta de la cinta es un enlace de verdad al video: sin JS, o con click del medio, se
     abre en TikTok. Con JS se queda en la página y el video se reproduce en #video-modal.
     El iframe se rellena RECIÉN al hacer click: si tuviera el src puesto en el HTML se cargarían
     9 reproductores de tiktok.com en cada visita.
     Va con delegación en el document (y no un listener por tarjeta) porque la marquesina clona
     las tarjetas: los clones también tienen que abrir el reproductor. */
  /* ⚠️ Las referencias se buscan AL CLICAR y no al arrancar: si la sección de TikTok se
     repinta en el personalizador, #video-modal es un nodo nuevo y una referencia guardada
     apuntaría al viejo, que ya no está en la página. */
  document.addEventListener('click', e => {
    const enlace = cerca(e, '.clip__link[data-video]');
    if (!enlace) return;
    const videoModal = document.getElementById('video-modal');
    const videoFrame = document.getElementById('video-frame');
    const videoLink  = document.getElementById('video-link');
    if (!videoModal || !videoFrame) return;
    e.preventDefault();
    e.stopPropagation();
    videoFrame.src = 'https://www.tiktok.com/embed/v2/' + enlace.dataset.video;
    videoFrame.title = enlace.getAttribute('aria-label') || 'TikTok video player';
    if (videoLink) videoLink.href = enlace.href;   /* la salida de emergencia apunta al mismo video */
    abrirVentana(videoModal, enlace);
  });

  /* ============================================================
     Marquesina — la cinta de videos de TikTok se desliza sola, sin flechas.
     El movimiento lo hace el CSS (@keyframes tk-cinta). Acá sólo dos cosas:
       1) se duplican las tarjetas hasta que sobre contenido, para que al reiniciarse el
          bucle no aparezca un hueco al final de la cinta, y
       2) se calcula la duración de la vuelta para que la velocidad sea siempre la misma
          (--tk-speed píxeles por segundo) sin importar cuántos videos haya.
     Marcá el contenedor con [data-marquee] y la lista con [data-marquee-track]. Para
     agregar un video basta con copiar un <li> en el HTML: acá no hay nada que tocar.
     ============================================================ */
  const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');


  /* ============================================================
     Entrada en cascada — cada sección aparece cuando entra en pantalla, y sus piezas lo hacen
     una tras otra en el orden del HTML (en el hero: primero el menú, después el título, el
     párrafo, el botón y la tarjeta de Match).

     Marcá la sección con [data-reveal] y cada pieza con [data-reveal-item]. Acá no hay nada que
     tocar para sumar una sección nueva. Los tiempos son tres manejadores del :root en el CSS:
     --rv-dur, --rv-step y --rv-shift.
     ============================================================ */
  const raiz = document.documentElement;
  const quietud = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let observador = null;

  function montarCascada() {
    if (!document.querySelector('[data-reveal]') || quietud || !('IntersectionObserver' in window)) {
      /* Sin cascada: se destapa todo de una. Es lo que ve quien pidió menos movimiento y
         también el respaldo si el navegador no trae IntersectionObserver. */
      raiz.classList.remove('con-cascada');
      raiz.dataset.cascadaLista = '1';
      return;
    }

    /* Esta marca apaga la red de seguridad del <head>: el JS ya se hizo cargo */
    raiz.dataset.cascadaLista = '1';

    if (!observador) {
      observador = new IntersectionObserver((entradas) => {
        entradas.forEach(entrada => {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('is-in');
          observador.unobserve(entrada.target);   /* una sola vez: no re-anima al volver a subir */
        });
      }, {
        /* Entra cuando la sección se asoma un 12% de la PANTALLA por encima del borde de abajo.
           ⚠️ Antes esto era threshold:0.12, o sea "un 12% de la SECCIÓN", y se rompió el día que
           la tienda pasó de 9 tarjetas a 48: una sección de ~8000px de alto nunca llega a
           enseñar el 12% de sí misma en una pantalla de 900px, así que el título y los filtros
           se quedaban invisibles PARA SIEMPRE. Medido. Con threshold:0 y el margen de abajo en
           negativo, el disparo depende de la pantalla y no del alto de la sección. */
        threshold: 0,
        rootMargin: '0px 0px -12% 0px'
      });
    }

    /* El retraso de cada pieza sale de su posición DENTRO de su sección, así que cada sección
       arranca su cascada de cero en vez de heredar el número de la anterior. */
    nuevos('[data-reveal]').forEach(bloque => {
      bloque.querySelectorAll('[data-reveal-item]').forEach((pieza, i) => {
        pieza.style.setProperty('--paso', i);
      });
      observador.observe(bloque);
    });
  }

  /* ---------- Escape: cierra lo que esté abierto ---------- */
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (abierta) cerrarVentana(abierta);
    closeAllHotspots(null);
  });

  /* ============================================================
     MONTAJE
     Todo lo que ata listeners a un elemento concreto vive acá dentro, y nuevos() se
     saltea lo que ya está montado. Se llama al arrancar y con cada shopify:section:load
     del personalizador, que repinta una sección sin recargar la página.
     ============================================================ */
  function montar() {
    /* ---------- puntos del hero ---------- */
    nuevos('.hotspot').forEach(hotspot => {
      const dot = hotspot.querySelector('.hotspot__dot');

      dot.addEventListener('click', e => {
        e.stopPropagation();
        const open = !hotspot.classList.contains('is-open');
        closeAllHotspots(hotspot);
        hotspot.classList.toggle('is-open', open);
        dot.setAttribute('aria-expanded', String(open));
      });
    });


    /* ---------- imágenes opcionales ---------- */
    activarOpcionales(document);

    /* ---------- aspa y fondo de las ventanas ---------- */
    /* Aspa y fondo oscurecido de todas las ventanas */
    nuevos('.modal').forEach(modal => {
      modal.querySelectorAll('[data-close]').forEach(el => {
        el.addEventListener('click', e => {
          e.stopPropagation();
          cerrarVentana(modal);
        });
      });
      /* Que un click dentro del panel no burbujee al listener de "click fuera" */
      const panel = modal.querySelector('.modal__panel');
      if (panel) panel.addEventListener('click', e => e.stopPropagation());
    });

    /* ---------- giro de la tarjeta en táctil ---------- */
    if (window.matchMedia('(hover: none)').matches) {
      nuevos('[data-match-flip]').forEach(tarjeta => {
        tarjeta.addEventListener('click', e => {
          /* Si el toque fue en el CTA se deja pasar: es un enlace, tiene que navegar */
          if (e.target.closest && e.target.closest('.match__cta')) return;
          e.preventDefault();
          tarjeta.classList.toggle('is-flip');
        });
      });
    }

    /* ---------- lupa de las reseñas ---------- */
    /* ---------- Lupa de las fotos de las reseñas ---------- */
    const lightbox = document.getElementById('lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    if (lightbox && lightboxImg) {
      const panelFoto = lightbox.querySelector('.modal__panel');

      /* El panel adopta la proporción real de la foto. Así queda ajustado a ella y el aspa
         cae sobre su esquina; si el panel fuera más ancho, el aspa flotaría en el vacío. */
      function aplicarProporcion() {
        if (!lightboxImg.naturalWidth) return;
        panelFoto.style.setProperty('--foto-ratio',
          lightboxImg.naturalWidth + ' / ' + lightboxImg.naturalHeight);
      }
      /* El listener de carga sólo se ata cuando la ventana es un nodo nuevo */
      if (nuevos('#lightbox').length) lightboxImg.addEventListener('load', aplicarProporcion);

      nuevos('.voice__shot').forEach(boton => {
        boton.addEventListener('click', e => {
          e.stopPropagation();
          const mini = boton.querySelector('img');
          lightboxImg.src = boton.dataset.zoom || (mini && mini.src) || '';
          lightboxImg.alt = mini ? mini.alt : '';
          /* Si la foto ya estaba en caché el evento load puede no volver a dispararse */
          if (lightboxImg.complete) aplicarProporcion();
          abrirVentana(lightbox, boton);
        });
      });
    }

    /* ---------- carruseles ---------- */
    nuevos('[data-carousel]').forEach(seccion => {
      const track = seccion.querySelector('[data-track]');
      const arrows = Array.from(seccion.querySelectorAll('[data-dir]'));
      if (!track || !arrows.length) return;

      /* Cuánto desplazar: el ancho de una tarjeta + el gap */
      function paso() {
        const item = track.firstElementChild;
        if (!item) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      /* Apaga la flecha que ya no tiene a dónde ir (2px de tolerancia: los navegadores
         redondean scrollLeft y nunca cae exacto) */
      function sincronizar() {
        const tope = track.scrollWidth - track.clientWidth;
        arrows.forEach(b => {
          const atras = Number(b.dataset.dir) < 0;
          b.disabled = atras ? track.scrollLeft <= 2 : track.scrollLeft >= tope - 2;
        });
      }

      /* Sin behavior: la animación la pone el CSS (scroll-behavior:smooth), que además
         respeta a quien tenga desactivadas las animaciones en su sistema. */
      arrows.forEach(b => b.addEventListener('click', () => {
        track.scrollBy({ left: paso() * Number(b.dataset.dir) });
        /* El evento scroll ya sincroniza, pero repetimos al terminar la animación por si
           el navegador no lo dispara: si no, una flecha podría quedarse apagada de más. */
        setTimeout(sincronizar, 450);
      }));

      track.addEventListener('scroll', sincronizar, { passive: true });
      window.addEventListener('resize', sincronizar);

      /* ⚠️ No alcanza con sincronizar UNA vez al montar: en ese instante la pista puede
         medir todavía lo mismo que su contenido (recién insertada por el personalizador,
         fotos sin cargar, fuente sin llegar) y las dos flechas nacen apagadas para
         siempre — scrollWidth - clientWidth da 0 y ninguna vuelve a mirar. Con el
         ResizeObserver se recalcula en cuanto la pista toma su ancho de verdad. */
      if ('ResizeObserver' in window) new ResizeObserver(sincronizar).observe(track);
      sincronizar();
    });

    /* ---------- cinta de TikTok ---------- */
    nuevos('[data-marquee]').forEach(viewport => {
      const track = viewport.querySelector('[data-marquee-track]');
      if (!track) return;

      /* Sólo las tarjetas de verdad: las copias que deja esta misma función llevan
         aria-hidden. Sin este filtro, montar la cinta dos veces sobre el mismo marcado
         (un repintado que arrastre las copias) las clonaría otra vez, y otra. */
      const originales = Array.from(track.children).filter(el => el.getAttribute('aria-hidden') !== 'true');
      if (!originales.length) return;

      /* Ancho de un juego completo de tarjetas. Cada tarjeta incluye su propio margen derecho
         (en el CSS el track no lleva gap), así que esta suma es exactamente lo que hay que
         desplazar para que la copia siguiente caiga donde estaba la primera. */
      function anchoJuego() {
        return originales.reduce((total, el) => {
          return total + el.getBoundingClientRect().width +
                 (parseFloat(getComputedStyle(el).marginRight) || 0);
        }, 0);
      }

      function montarCinta() {
        /* Se parte de cero: al cambiar el ancho de pantalla cambia --tk-w y hacen falta
           otras tantas copias */
        viewport.classList.remove('is-live');
        while (track.children.length > originales.length) track.lastElementChild.remove();

        /* Con animaciones desactivadas no se clona nada: queda la cinta arrastrable a mano */
        if (sinMovimiento.matches) return;

        const juego = anchoJuego();
        if (!juego) return;

        /* Hace falta un juego para desplazar + lo que ocupe la pantalla mientras se desplaza,
           de ahí el 1 + pantalla/juego. Mínimo 2, que es lo que pide el @keyframes. */
        const copias = Math.max(2, Math.ceil(1 + viewport.clientWidth / juego));

        for (let i = 1; i < copias; i++) {
          originales.forEach(el => {
            const copia = el.cloneNode(true);
            copia.setAttribute('aria-hidden', 'true');       /* no se lee el mismo video 3 veces */
            copia.querySelectorAll('a, button').forEach(f => f.setAttribute('tabindex', '-1'));
            activarOpcionales(copia);
            track.appendChild(copia);
          });
        }

        const velocidad = parseFloat(getComputedStyle(viewport).getPropertyValue('--tk-speed')) || 45;
        track.style.setProperty('--tk-copies', copias);
        track.style.animationDuration = (juego / velocidad) + 's';
        viewport.classList.add('is-live');
      }

      montarCinta();

      let esperando;
      window.addEventListener('resize', () => {
        clearTimeout(esperando);
        esperando = setTimeout(montar, 200);
      });
      if (sinMovimiento.addEventListener) sinMovimiento.addEventListener('change', montar);
    });

    /* ---------- entrada en cascada ---------- */
    montarCascada();
  }

  montar();

  /* El personalizador de Shopify. Sin esto, editar una sección la deja sin JS hasta que
     el merchant recarga a mano: el <script> no se vuelve a ejecutar. */
  document.addEventListener('shopify:section:load', function () { montar(); });

})();

}